module.exports = __webpack_public_path__ + "img/Werk_NN_2a.51f3a045.png";